import * as yup from 'yup';

export const formatSSNInput = (value = '') =>
  value.replace(/\D/g, '').slice(0, 9);

export const formatPostcodeInput = (value = '') =>
  value.replace(/\D/g, '').slice(0, 5);

export const searchValidationSchema = yup.object({
  ssn: yup
    .string()
    .required('SSN is required')
    .matches(/^\d{9}$/, 'Enter a valid 9-digit SSN'),
  postcode: yup
    .string()
    .required('Postcode is required')
    .matches(/^\d{5}$/, 'Enter a valid 5-digit postcode'),
});
